import PropTypes from "prop-types";
import TableCell from "../TableCell";

const TableRow = ({ columns, row, index }) => {
  return (
    <>
      <tr key={index} role="row">
        {columns.map((column, index) => (
          <TableCell key={index} column={column} row={row} />
        ))}
      </tr>
    </>
  );
};

TableRow.propTypes = {
  columns: PropTypes.array,
  row: PropTypes.object,
  index: PropTypes.number,
};

export default TableRow;
